export const avatarBackgroundColors = [
  '#F3B923',
  '#AFD5C6',
  '#E7A655',
  '#4957A2',
  '#245EF0',
  '#F3B923',
  '#AFD5C6',
  '#E7A655',
  '#4957A2',
  '#245EF0',
];
